import React, { useEffect } from 'react';
import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import { AccountBalance, Security as SecurityIcon } from '@mui/icons-material';
import PlaidConnectionsSettings from './PlaidConnectionsSettings';
import SecuritySettings from './SecuritySettings';

function TabPanel({ children, value, index }) {
    if (value !== index) return null;
    return <Box sx={{ pt: 3 }}>{children}</Box>;
}

/**
 * Settings hub: bank connections (Plaid) and security (MFA).
 * Use ?tab=security for the Security tab; default is Connections.
 */
function Settings() {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = (searchParams.get('tab') || '').toLowerCase();
    const tabIndex = tabParam === 'security' ? 1 : 0;

    const handleTabChange = (_, newIndex) => {
        if (newIndex === 0) {
            setSearchParams({}, { replace: true });
        } else {
            setSearchParams({ tab: 'security' }, { replace: true });
        }
    };

    useEffect(() => {
        document.title = 'Settings — Ohana Financial';
    }, []);

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#f4f6fb', py: { xs: 2, md: 4 }, px: { xs: 2, md: 3 } }}>
            <Box sx={{ maxWidth: 960, mx: 'auto' }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#1a237e', mb: 0.5 }}>
                    Settings
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                    Manage linked banks and account security
                </Typography>

                <Paper elevation={0} sx={{ borderRadius: 3, overflow: 'hidden', border: '1px solid', borderColor: 'divider' }}>
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        variant="fullWidth"
                        sx={{
                            borderBottom: 1,
                            borderColor: 'divider',
                            bgcolor: 'white',
                            '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, py: 2 },
                        }}
                    >
                        <Tab icon={<AccountBalance sx={{ fontSize: 20, mb: 0.25 }} />} iconPosition="start" label="Connections" />
                        <Tab icon={<SecurityIcon sx={{ fontSize: 20, mb: 0.25 }} />} iconPosition="start" label="Security" />
                    </Tabs>

                    <Box sx={{ px: { xs: 2, sm: 3 }, pb: 3, bgcolor: 'white' }}>
                        <TabPanel value={tabIndex} index={0}>
                            <PlaidConnectionsSettings />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <SecuritySettings embedded />
                        </TabPanel>
                    </Box>
                </Paper>

                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2, textAlign: 'center' }}>
                    <Link to="/linked-accounts" style={{ color: '#5c6bc0' }}>Back to Accounts & cash flow</Link>
                </Typography>
            </Box>
        </Box>
    );
}

export default Settings;
